import React, { useEffect, useContext } from 'react'
import { NextpageContext } from '../context/nextpage.context'

const Alert = (props: any) => {
  const nextpage = useContext(NextpageContext)
  useEffect(() => {
    nextpage.UI.components.alert()
  })
  return (
    <React.Fragment>
      <div id='alert-shim-wrap'>
        <div id='alert-shim'>
          <a id='alert-shim-close' href='#'>
            close
          </a>
          {props.children}
        </div>
      </div>
    </React.Fragment>
  )
}

export default Alert
